module.exports = __webpack_public_path__ + "img/ear-wheat.3592180.png";